<template>
  <v-container data-aos="fade">
    <h1 class="text-center">{{title}}</h1>
    <p>CHEF NATURELLE (“We”) are committed to respecting the privacy of your personal information and protecting it in accordance with all applicable Data Protection Laws (including the Directive 96/46/EC (Data Protection Directive) and the General Data Protection Regulation (EU) 016/679 (GDPR) for as long as the GDPR is effective in the UK).</p>
    <p>This privacy policy describes how We use and process your personal information and applies between you, the user of this website and/or the customer of our services and products and CHEF NATURELLE. Please read the following carefully.</p>

    <h4>WHY WE COLLECT YOUR INFORMATION</h4>
    <p>We need certain information about you in order to provide our website and services to you. We do not sell or share your personal information with third parties for their own marketing purposes.</p>

    <h4>THE LAWFUL BASIS ON WHICH WE COLLECT INFORMATION</h4>
    <p>We collect and process information on the basis of your explicit consent in order to perform our contractual obligations, conduct our business in an efficient manner and/or to comply with legal and regulatory obligations.</p>

    <h4>WHAT INFORMATION WE COLLECT</h4>
    <p>We may collect the following information about you:</p>
    <ul>
      <li>you fill in a form on our website</li>
      <li>you contact us (by phone, email, social media, in person)</li>
      <li>you attend an event</li>
      <li>you place an order for any products or services or make a booking</li>
      <li>you subscribe to our newsletter</li>
      <li>you submit payment information to us.</li>
    </ul>

    <h4>HOW WE USE YOUR INFORMATION</h4>
    <p>We collect your information in order to:</p>
    <ul>
      <li>Identify you</li>
      <li>Process your orders and bookings</li>
      <li>Send you newsletters you have subscribed to</li>
      <li>Improve our products or services.</li>
    </ul>

    <h4>HOW WE SHARE YOUR PERSONAL INFORMATION</h4>
    <p>We may share your personal information with the following third parties and for the following reasons:</p>
    <ul>
      <li>the relevant third party suppliers for the purposes of authorising and validating payment, hosting and supporting our website, distributing our newsletter, accounts.</li>
      <li>the relevant authorities in order to comply with legal obligation, to protect the rights, property, or safety of us, our customers, or others.</li>
    </ul>

    <h4>HOW WE KEEP YOUR PERSONAL INFORMATION SAFE</h4>
    <p>We use technical and organisational measures to safeguard your information by storing it on secure servers and access to personal information is restricted to authorised individuals who need it to perform their work.</p>
    <p>Our website may contain links to and from other websites. If you follow a link to any of those sites, please note that We do not accept any responsibility or liability for those sites or for their privacy policies. As a result, We encourage you to check those privacy policies.</p>

    <h4>HOW LONG WE KEEP YOUR INFORMATION</h4>
    <p>We will not keep your personal information for longer than necessary to fulfil the purposes outlined in this privacy policy or until you request that the information is deleted.</p>

    <h4>TRANSFERS OUTSIDE OF EUROPE</h4>
    <p>We do not transfer your personal information outside of the European Economic Area and in the unlikely event that We need to do so, We will ensure that they comply with Data Protection Laws.</p>

    <h4>YOUR DATA PROTECTION RIGHTS</h4>
    <p>We would like to make sure that you are fully aware of all your data protection rights:</p>
    <ul>
      <li>Right to be informed: You have the right to know what data We collect, how it is being used, how long it will be kept and whether We share it with any third parties.</li>
      <li>Right to access: You have the right to request a copy of the information We hold on You.</li>
      <li>Right to rectification: You have the right to request that We correct any of your data that you believe is inaccurate or incomplete.</li>
      <li>Right to erasure: You have the right to request that We erase your data from our systems in the certain circumstances.</li>
      <li>Right to restrict processing: You have the right to request that We restrict our processing on specified grounds.</li>
      <li>Right to data portability: You have the right to request that We transfer the information We have collected to another organisation, or directly to you, in specific circumstances.</li>
      <li>Right to object: In certain circumstances, You have the right to object to our processing of your information, such as marketing.</li>
    </ul>
    <p>If you would like to exercise any of these rights, please contact us at <a href="mailto:contact@chefnaturelle.com">contact@chefnaturelle.com</a>.</p>

    <h4>YOUR RIGHT TO WITHDRAW YOUR CONSENT</h4>
    <p>If you have signed up to our newsletter, you can remove your details from the subscription list by clicking <router-link to="/unsubscribe">here</router-link>.</p>

    <h4>CHANGES TO OUR PRIVACY POLICY</h4>
    <p>We may update this privacy policy from time to time in order to reflect, for example, changes to our practices or for other operational, legal or regulatory reasons. Any updates will be posted on this page.</p>

    <h4>HOW TO CONTACT US</h4>
    <p>Under the GDPR, We are the data controller of the personal information We collect about you meaning that We determine the purposes for which, and the manner in which, your information is processed. We welcome any questions you may have about Our privacy policy, the information We hold or if you would like to exercise one of your data protection rights, please contact us by email at
      <a href="mailto:contact@chefnaturelle.com">contact@chefnaturelle.com</a>.</p>

    <h4>HOW TO CONTACT THE APPROPRIATE AUTHORITY</h4>
    <p>If you feel that We have not addressed your concern in relation to your personal information in a satisfactory manner or should you wish to report a complaint, you have the right to lodge a complaint with the Information Commissioner’s Office (ICO) whose contact details can be found on their website at <a href="https://ico.org.uk/" target="_blank">https://ico.org.uk/</a>.</p>

    <p>This privacy policy was last revised on  9th August 2019.</p>
  </v-container>
</template>

<script>
import {
  VContainer,
} from 'vuetify/lib'
import MetaInfoBuilder from '@/utils/social'

export default {
  components: {
    VContainer,
  },
  data() {
    return {
      title: 'Privacy Policy'
    }
  },
  metaInfo() {
    return new MetaInfoBuilder()
      .description(this.title)
      .title(this.title)
      .build()
  }
}
</script>

<style lang="scss" scoped>
h1 {
  margin-top: 30px;
  font-family: 'Nanum Myeongjo', serif !important;
  font-size: 50px !important;
  color: rgba(0, 0, 0, 0.87);
}

h4 {
  text-align: left;
}

p, li {
  font-size: 15px;
}
</style>
